/** Small deterministic helpers for the procedural canvases. */

function hash3(x: number, y: number, z: number): number {
  let n = Math.imul(x, 374761393) ^ Math.imul(y, 668265263) ^ Math.imul(z, 1274126177);
  n = Math.imul(n ^ (n >>> 13), 1103515245);
  return ((n ^ (n >>> 16)) >>> 0) / 4294967295;
}

const fade = (t: number) => t * t * (3 - 2 * t);

/** Smooth value noise in three dimensions, 0..1. */
export function noise3(x: number, y: number, z: number): number {
  const xi = Math.floor(x);
  const yi = Math.floor(y);
  const zi = Math.floor(z);
  const u = fade(x - xi);
  const v = fade(y - yi);
  const w = fade(z - zi);

  const mix = (a: number, b: number, t: number) => a + (b - a) * t;
  const plane = (k: number) =>
    mix(
      mix(hash3(xi, yi, k), hash3(xi + 1, yi, k), u),
      mix(hash3(xi, yi + 1, k), hash3(xi + 1, yi + 1, k), u),
      v,
    );

  return mix(plane(zi), plane(zi + 1), w);
}

/** Seeded random number generator (mulberry32), so scenes look the same on every visit. */
export function seeded(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
